import * as React from 'react';

import { useRouter } from 'next/router';

import LieuucationReport from '@components/Lieuucation/LieuucationReport';

const LieuucationPage: React.FC<{}> = () => {
  const router = useRouter();

  const lieuucationId = router.query && String(router.query.id);

  return <LieuucationReport lieuucationId={lieuucationId} />;
};

export default LieuucationPage;
